module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/zh-hans_shikoku-aecdb84bdb8a34377dde6b9bd8236fb7.jpg";